export default function redirector(url, target = '_self') {
	const locale = sessionStorage.getItem('locale')
	const localeString = locale ? `/${locale}` : ''

	// Alternate way to open new tab
	// Object.assign(document.createElement("a"), {
	//   target: target,
	//   href: `${localeString}${url}`
	// }).click();

	const windowObj = window.open(`${localeString}${url}`, target)
	return windowObj
}
